module.exports = "/_next/static/images/sc-049e72080b461d916d501be3418be9fb.svg";